<template>
  <!-- <tri-manager
    :table-fetch="tableFetch"
    :table-fetch-active="tableFetchActive"
    :table-archive="tableArchive"
    :table-restore="tableRestore"
    :table-columns="tableColumns"
  /> -->
  <contract-association-manager
    :assoc-fetch="tableFetch"
    :assoc-fetch-active="tableFetchActive"
    :assoc-archive="tableArchive"
    :assoc-restore="tableRestore"
    :table-columns="tableColumns"
  />
</template>

<script>
import ContractAssociationManager from "@/components/Contract/ContractAssociationManager";
// import TriManager from "@/components/Tri/TriManager";
import { CodeService } from "@/services/code.service";
import { AssetService } from "@/services/asset.service";

export default {
  components: {
    ContractAssociationManager,
    // TriManager,
  },
  data: () => ({
    tableColumns: [
      {
        field: "group",
        label: "Group",
      },
      {
        field: "code",
        label: "Code",
      },
      {
        field: "name",
        label: "Name",
      },
    ],
  }),
  methods: {
    async tableFetch(payload) {
      // Fetch master asset codes
      // return await AssetService.listCodes(payload);
      return await CodeService.all({
        firm_id: this.$store.state.Auth.user.firmId,
        firm_include_archived: 1,
        type: "ASSET",
      });
    },
    // async tableFetch(payload) {
    //   // Fetch master asset codes
    //   return await AssetService.listCodes({
    //     ...payload,
    //     contract_ids: payload.contract_id ? [payload.contract_id] : undefined,
    //   });
    // },
    async tableFetchActive(payload) {
      // Fetch active asset codes
      return await AssetService.listCodes({
        ...payload,
        contract_ids: payload.contract_id ? [payload.contract_id] : undefined,
      });
    },
    async tableArchive(payload) {
      // Archive asset-contract relationships
      if (payload.contract_id || payload.contract_ids) {
        await AssetService.archiveContracts({
          codeId: payload.id,
          contract_ids: payload.contract_id
            ? [payload.contract_id]
            : payload.contract_ids,
        });
      }
    },
    // async tableArchive(payload) {
    //   // Archive asset-contractType relationships
    //   if (payload.contract_type_tag_id) {
    //     await AssetService.archiveContractTypeTags({
    //       codeId: payload.id,
    //       contract_type_tag_ids: [payload.contract_type_tag_id],
    //     });
    //   }
    //   // Archive asset-contract relationships
    //   if (payload.contract_id) {
    //     await AssetService.archiveContracts({
    //       codeId: payload.id,
    //       contract_ids: [payload.contract_id],
    //     });
    //   }
    // },
    async tableRestore(payload) {
      // Archive asset-contract relationships
      if (payload.contract_id || payload.contract_ids) {
        await AssetService.restoreContracts({
          codeId: payload.id,
          contract_ids: payload.contract_id
            ? [payload.contract_id]
            : payload.contract_ids,
        });
      }
    },
    // async tableRestore(payload) {
    //   // Restore asset-contractType relationships
    //   if (payload.contract_type_tag_id) {
    //     await AssetService.restoreContractTypeTags({
    //       codeId: payload.id,
    //       contract_type_tag_ids: [payload.contract_type_tag_id],
    //     });
    //   }
    //   // Restore asset-contract relationships
    //   if (payload.contract_id) {
    //     await AssetService.restoreContracts({
    //       codeId: payload.id,
    //       contract_ids: [payload.contract_id],
    //     });
    //   }
    // },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationSettingsAssets.vue